var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"card-block"},[_vm._t("default")],2),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a536023c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Cards/Card.vue
// module id = EUqX
// module chunks = 1